// extracted by mini-css-extract-plugin
export default {"pinned":"pinned___yTp_7","floated":"floated___YSwG9","notATradingCell":"notATradingCell___l9Hzq","brandImage":"brandImage___oZlUi"};